module.exports = __webpack_public_path__ + "static/img/jijinhui03.578e453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dymanticLanshu/jijinhui03.jpg
// module id = Edqr
// module chunks = 0